<template>
  <v-application>
    <v-card width="700" class="ma-2">
      <v-progress-linear
        v-if="uploading"
        :value="uploadPercentageDocument"
        :indeterminate="uploadPercentageDocument == 100 && uploading"
      ></v-progress-linear>
      <v-card-title v-if="upload_error">Import errors</v-card-title>
      <v-card-title v-else-if="default_ui">Import items</v-card-title>
      <v-card-title v-else>Confirm import</v-card-title>
      <v-card-text v-if="upload_error">
        <v-list-item class="pt-2">
          <v-icon x-large color="error">mdi-alert</v-icon>
          <v-list-item-content class="pl-3">
            <v-list-item-title class="error--text font-weight-bold">{{
              error_message
            }}</v-list-item-title>
            <v-list-item-subtitle
              >Fix errors in the importing file and try downloading
              again.</v-list-item-subtitle
            >
          </v-list-item-content>
        </v-list-item>
        <v-divider></v-divider>
        <v-list-item
          class="py-2"
          v-for="(itm, ind) in upload_errors"
          :key="ind"
        >
          <v-icon large>mdi-alert</v-icon>
          <v-list-item-content class="pl-3">
            <v-list-item-title class="black--text font-weight-bold"
              >Cell: {{ upload_errors[ind].place }}</v-list-item-title
            >
            <v-list-item-subtitle>{{
              upload_errors[ind].Error
            }}</v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
      </v-card-text>
      <v-card-text v-else-if="default_ui">
        <p>
          <v-hover v-slot:default="{ hover }">
            <a
              class="mr-1"
              :class="hover ? 'red--text' : 'blue--text'"
              @click="downloading"
              >Download template file</a
            > </v-hover
          >and fill in with the items information.
        </p>
        <div
          :class="[
            'dropzone-area',
            dragging || file != null ? 'dropzone-over' : '',
          ]"
          drag-over="handleDragOver"
          @dragenter="dragging = true"
          @dragleave="dragging = false"
        >
          <div class="dropzone-text">
            <v-list-item class="py-10">
              <v-icon v-if="error" size="80" color="error"
                >mdi-file-remove</v-icon
              >
              <v-icon v-else size="80">mdi-file-document-outline</v-icon>
              <v-list-item-content v-if="error" class="text-left">
                <v-list-item-title class="error--text"
                  >File error</v-list-item-title
                >
                <v-list-item-subtitle
                  >Please upload the CSV file.</v-list-item-subtitle
                >
              </v-list-item-content>
              <v-list-item-content v-else-if="file == null" class="text-left">
                <v-list-item-title
                  >Drag and drop your file here</v-list-item-title
                >
                <v-list-item-subtitle class="subtitle"
                  >or select it on the computer</v-list-item-subtitle
                >
              </v-list-item-content>
              <v-list-item-content v-else class="text-left">
                <v-list-item-title>{{ file.name }}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </div>
          <input type="file" accept=".csv" @change="onFileChange" />
        </div>
      </v-card-text>
      <v-card-text v-else>
        <p>
          Please confirm the changes. By continuing you will not be able to
          return to the previous list of items.
        </p>
        <v-divider></v-divider>
        <v-list-item v-if="created_item > 0" class="py-2">
          <v-btn fab :elevation="0" small color="#689F38">
            <v-icon color="white">mdi-file-document</v-icon>
          </v-btn>
          <v-list-item-content class="pl-3 font-weight-bold"
            >{{ created_item }} item will be created</v-list-item-content
          >
        </v-list-item>
        <v-list-item v-if="created_category > 0" class="py-2">
          <v-btn fab :elevation="0" small color="#689F38">
            <v-icon color="white">mdi-folder</v-icon>
          </v-btn>
          <v-list-item-content class="pl-3 font-weight-bold"
            >{{ created_category }} category will be
            created</v-list-item-content
          >
        </v-list-item>
        <v-list-item v-if="created_supplier > 0" class="py-2">
          <v-btn fab :elevation="0" small color="#689F38">
            <v-icon color="white">mdi-truck</v-icon>
          </v-btn>
          <v-list-item-content class="pl-3 font-weight-bold"
            >{{ created_supplier }} supplier will be
            created</v-list-item-content
          >
        </v-list-item>
        <v-list-item v-if="edited_item > 0" class="py-2">
          <v-btn fab :elevation="0" small color="#689F38">
            <v-icon color="white">mdi-pencil</v-icon>
          </v-btn>
          <v-list-item-content class="pl-3 font-weight-bold"
            >{{ edited_item }} item will be edited</v-list-item-content
          >
        </v-list-item>
        <v-divider></v-divider>
      </v-card-text>
      <v-card-actions>
        <v-btn text>Help</v-btn>
        <v-spacer />
        <v-btn text @click="cancelClicked">Cancel</v-btn>
        <v-btn v-if="upload_error" text color="primary" @click="retryClicked"
          >Retry</v-btn
        >
        <v-btn
          v-else-if="confirm_uploaded"
          text
          :disabled="file == null || uploading"
          color="primary"
          :loading="uploading"
          @click="confirmClicked"
          >Confirm Import</v-btn
        >
        <v-btn
          v-else
          :loading="uploading"
          text
          :disabled="file == null || uploading"
          color="primary"
          @click="uploadClicked"
          >Upload</v-btn
        >
      </v-card-actions>
    </v-card>
  </v-application>
</template>

<script>
function getExt(filepath) {
  return filepath.split("?")[0].split("#")[0].split(".").pop();
}
const axios = require("axios");

export default {
  name: "Import",
  data: () => ({
    org: "",
    uploadPercentageDocument: 0,
    created_item: 0,
    created_category: 0,
    created_supplier: 0,
    edited_item: 0,
    error_message: "",
    default_ui: true,
    upload_error: false,
    confirm_uploaded: false,
    upload_errors: [
      {
        Error: "SKU field cannot be blank",
        place: "B2",
      },
    ],
    uploading: false,
    file: null,
    image: "",
    error: false,
    dragging: false,
    token: "",
    timeout: 5 * 60 * 1000,
    // BASE_URL: "http://api.r.invan.uz/"
    // BASE_URL: "http://localhost:3000/"
  }),
  computed: {
    BASE_URL() {
      return this.$communicator.base_url + "invan-upload/";
    },
  },
  methods: {
    downloadTemp() {
      this.$communicator.download(
        "goods/sales/export/" + this.org + "/temp_file.csv"
      );
    },
    downloading() {
      let link = "goods/sales/export/" + this.org + "/items_temp.csv";
      this.$communicator.download(link);
    },
    onFileChange(e) {
      var files = e.target.files || e.dataTransfer.files;
      if (!files.length) return;
      this.createImage(files[0]);
      this.file = files[0];
    },
    createImage(file) {
      var reader = new FileReader();
      var vm = this;
      reader.onload = (e) => {
        vm.image = e.target.result;
      };
      reader.readAsDataURL(file);
    },
    cancelClicked() {
      this.default_ui = true;
      this.upload_error = false;
      this.confirm_uploaded = false;
      this.error = false;
      this.dragging = false;
      if (this.file == null) {
        this.$router.push("/items/list").catch(() => {});
      } else {
        this.file = null;
      }
    },
    retryClicked() {
      this.file = null;
      this.default_ui = true;
      this.upload_error = false;
      this.confirm_uploaded = false;
      this.error = false;
      this.dragging = false;
    },
    confirmClicked() {
      if (this.file) {
        if (getExt(this.file.name) != "csv") {
          this.error = true;
        } else {
          this.uploading = true;
          const f = new FormData();
          f.append("excel", this.file);
          var self = this;
          // const httpClient = axios.create();
          axios.defaults.timeout = this.timeout;
          axios
            .post(this.BASE_URL + "upload_excel_file_mxik", f, {
              timeout: this.timeout,
              headers: {
                "Content-Type": "multipart/form-data",
                "Accept-Version": "1.0.0",
                "Accept-User": "admin",
                Authorization: this.token,
                save: true,
              },
              onUploadProgress: function (progressEvent) {
                if (progressEvent.loaded == progressEvent.total) {
                  self.loading_image = true;
                }
                this.uploadPercentageImage = parseInt(
                  Math.round((progressEvent.loaded / progressEvent.total) * 100)
                );
              }.bind(this),
            })
            .then(function (res) {
              // setTimeout(() => {
              self.uploading = false;
              if (res && res.data && res.data.statusCode == 205) {
                self.upload_errors = res.data.errors;
                self.error_message =
                  "Errors found: " + this.upload_errors.length;
                self.upload_error = true;
              } else if (res && res.data && res.data.statusCode == 200) {
                self.$router.push("/items/list").catch(() => {});
              } else {
                self.error_message = "Couldn't import try again!";
                self.upload_error = true;
                self.upload_errors = [];
              }
              // }, 5000);
            })
            .catch(function () {
              // setTimeout(() => {
              self.uploading = false;
              self.error_message = "Couldn't upload try again!";
              self.upload_errors = [];
              self.upload_error = true;
              // }, 5000);
            });
        }
      }
    },
    uploadClicked() {
      if (this.file) {
        if (getExt(this.file.name) != "csv") {
          this.error = true;
        } else {
          this.uploading = true;
          const f = new FormData();
          f.append("excel", this.file);
          var self = this;
          axios.defaults.timeout = this.timeout;
          axios
            .post(this.BASE_URL + "upload_excel_file_mxik", f, {
              timeout: this.timeout,
              headers: {
                "Content-Type": "multipart/form-data",
                "Accept-Version": "1.0.0",
                "Accept-User": "admin",
                Authorization: this.token,
                save: false,
              },
              onUploadProgress: function (progressEvent) {
                if (progressEvent.loaded == progressEvent.total) {
                  self.loading_image = true;
                }
                this.uploadPercentageDocument = parseInt(
                  Math.round((progressEvent.loaded / progressEvent.total) * 100)
                );
              }.bind(this),
            })
            .then(function (res) {
              // setTimeout(() => {
              self.uploading = false;
              if (res && res.data && res.data.statusCode == 205) {
                self.upload_error = true;
                self.upload_errors = res.data.errors;
              } else if (res && res.data && res.data.statusCode == 200) {
                self.created_item = res.data.data.goods_created;
                self.created_category = res.data.data.category_created;
                self.created_supplier = res.data.data.supplier_created;
                self.edited_item = res.data.data.goods_updated;
                self.default_ui = false;
                self.confirm_uploaded = true;
              } else if (res && res.data && res.data.statusCode == 422) {
                self.error_message = res.data.message;
                self.upload_errors = [];
                self.upload_error = true;
              } else {
                self.error_message = "Couldn't upload try again!";
                self.upload_errors = [];
                self.upload_error = true;
              }
              // }, 5000);
            })
            .catch(function () {
              // setTimeout(() => {
              self.uploading = false;
              self.error_message = "Couldn't upload try again!";
              self.upload_errors = [];
              self.upload_error = true;
              // }, 5000);
            });
        }
      }
    },
  },
  mounted() {
    this.token = this.$store.state.token;
    this.org = this.$route.query.org;
  },
};
</script>

<style scoped>
.dropzone-over {
  background-color: #f2f2f2;
}
.dropzone-area {
  width: 100%;
  height: 200px;
  position: relative;
  border: 2px dashed #cbcbcb;
}
.dropzone-area input {
  position: absolute;
  cursor: pointer;
  top: 0px;
  right: 0;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 100%;
  opacity: 0;
}
.dropzone-text {
  position: absolute;
  top: 50%;
  text-align: center;
  transform: translate(0, -50%);
  width: 100%;
}
.dropzone-title {
  font-size: 13px;
  color: #787878;
  letter-spacing: 0.4px;
}
.dropzone-info {
  font-size: 13px;
  font-size: 0.8125rem;
  color: #a8a8a8;
  letter-spacing: 0.4px;
}
.dropzone-button {
  position: absolute;
  top: 10px;
  right: 10px;
  display: none;
}
.dropzone-preview {
  width: 80%;
  position: relative;
}
.subtitle {
  text-decoration: underline;
}
.v-btn {
  text-transform: none !important;
}
</style>
